import React from 'react';
import './Culture.css';

const Culture = () => {
  const cultureItems = [
    {
      id: 1,
      description: "Born from the streets, built for the underground. We create clothing that represents the raw energy and anonymity of urban culture.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="3"/>
          <path d="M12 1v6m0 6v6"/>
          <path d="m21 12-6 0m-6 0-6 0"/>
          <path d="m19.07 4.93-4.24 4.24m-6.36 6.36-4.24 4.24"/>
          <path d="m19.07 19.07-4.24-4.24m-6.36-6.36-4.24-4.24"/>
        </svg>
      )
    },
    {
      id: 2,
      description: "Quality meets rebellion. Every piece is crafted with precision and designed to withstand the intensity of street life.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <path d="M9 12l2 2 4-4"/>
        </svg>
      )
    }
  ];

  return (
    <section id="culture" className="culture-section">
      <div className="container">
        <div className="culture-header">
          <h2 className="section-title">Our Culture</h2>
        </div>
        <div className="culture-cards">
          {cultureItems.map((item) => (
            <div key={item.id} className="culture-card">
              <div className="culture-icon">
                {item.icon}
              </div>
              <p className="culture-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Culture;
